import ApiService from './ApiService';

export default class LocationBikeApi extends ApiService {
    getAllLocationBike(payload) {
        return this.get('customer/locations/recent', payload);
    }

    getLocationBikeDetail(payload) {
        const { id, ...otherPayload } = payload;
        return this.get(`customer/locations/${id}`, otherPayload);
    }

    getAllBikeInLocation(payload) {
        const { id, ...data } = payload;
        return this.get(`customer/bikes/locations/${id}`, data);
    }

    getAllBikeAvailableInLocation(payload) {
        const { locationId, ...data } = payload;
        return this.get(`system/bikes-available-locations/${locationId}`, data);
    }
}
